import { Head, useForm } from '@inertiajs/react'
import { SubmitEvent } from 'react'
import { Flex } from '@radix-ui/themes'
import MediaGroupForm from './_form'
import SetupForEventCallout, { setupPath } from '@/shared/events/SetupForEventCallout'
import { MediaGroupFormData } from '@/types/shared'
import { MediaGroupParticipantsNewProps } from '@/types/media_group_participants_new'

export default function NewMediaGroupParticipant({
  errors,
  event_id,
  event_name,
}: MediaGroupParticipantsNewProps) {
  const { data, setData, post, processing } = useForm<MediaGroupFormData>({
    participant: {
      name: '',
      location: '',
      email: '',
      phone_number: '',
      instagram: '',
      youtube: '',
      flickr: '',
      facebook: '',
      tiktok: '',
      threads: ''
    },
    media_group: {
      primary_outlet: '',
      portfolio_link: '',
      listing: 'photography',
      logo: null
    }
  })

  const handleSubmit = (e: SubmitEvent) => {
    e.preventDefault()
    post(setupPath('/media_group_participant', { event_id, event_name }), { forceFormData: true })
  }

  return (
    <>
      <Head title="Create Media Group Profile" />
      <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto" }}>
        <Flex direction="column" gap="4">
          <SetupForEventCallout event_id={event_id} event_name={event_name} />
          <MediaGroupForm
            data={data}
            setData={setData}
            onSubmit={handleSubmit}
            processing={processing}
            errors={errors}
            title="Create Media Group Profile"
            submitLabel="Create Media Group Profile"
          />
        </Flex>
      </div>
    </>
  )
}
